import { useState } from "react";
import { useReverification, useUser } from "@clerk/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/member/MemberOverview";

export const SetPassword = () => {
  const { user } = useUser();
  const [pw, setPw] = useState("");
  const [current, setCurrent] = useState("");
  const update = useReverification((params) => user.updatePassword(params));
  if (!user) return null;
  const has = user.passwordEnabled;
  const save = async () => {
    try {
      await update({ newPassword: pw, ...(has ? { currentPassword: current } : {}), signOutOfOtherSessions: true });
      toast.success("Password saved. You can now sign in with your Distributor ID and password.");
      setPw("");
      setCurrent("");
    } catch (e) {
      toast.error(e?.errors?.[0]?.longMessage || e?.errors?.[0]?.message || "Could not update password");
    }
  };
  return (
    <Card title="Login password" testid="member-set-password">
      <p className="mb-3 text-sm text-slate-600">{has ? "Change the password you use with your Distributor ID." : "Set a password so you can sign in with your Distributor ID and password."}</p>
      <div className="flex flex-wrap gap-2">
        {has && <Input type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className="max-w-xs" data-testid="current-password" />}
        <Input type="password" placeholder="New password (min 8 characters)" value={pw} onChange={(e) => setPw(e.target.value)} className="max-w-xs" data-testid="new-password" />
        <Button className="rounded-full" disabled={pw.length < 8 || (has && !current)} onClick={save} data-testid="save-password">{has ? "Change password" : "Set password"}</Button>
      </div>
    </Card>
  );
};
